import { css } from '@emotion/core'
import React from 'react'

import { colors, Typography } from '@dw/helix'

const statusesStyles = {
  NORMAL: css`
    background-color: #fff;
    color: ${colors.brandBlue};
    border: 1px solid ${colors.grey4};
  `,
  SUCCESS: css`
    background-color: ${colors.green};
    color: #fff;
  `,
  DANGER: css`
    background-color: ${colors.yellow};
  `,
}

export enum TableBadgeStatus {
  normal = 'NORMAL',
  success = 'SUCCESS',
  danger = 'DANGER',
}

interface TableBadgeProps {
  text: string
  status: TableBadgeStatus
}

export const TableBadge = ({ text, status }: TableBadgeProps) => (
  <div style={{ display: 'flex' }}>
    <Typography
      type="label"
      css={css`
        padding: 4px 0 3px;
        min-width: 54px;
        display: flex;
        justify-content: center;
        ${statusesStyles[status]};
      `}
    >
      {text}
    </Typography>
  </div>
)

export default TableBadge
